<template>
  <span
    class="badge"
    :class="`badge${variant === 'primary' ? '--primary' : '--outline'}`"
  >
    <slot></slot>
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Badge',
  props: {
    variant: {
      type: String,
      default: 'primary',
      validator: (value: string) => ['primary', 'outline'].includes(value),
    },
  },
})
</script>

<style lang="scss">
.badge {
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.5rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1;
  background-color: #0066b3;
  color: white;
}

.badge--primary {
  background-color: #0066b3;
  color: white;
}

.badge--outline {
  background-color: var(--yhc-color-55);
  border: 1px solid #0066b3;
  color: #0066b3 !important;
}
</style>
